import { Box, Paper, Typography } from '@mui/material';
import React, { useContext } from 'react';
import UserContext from 'Shared/UserContext';
// import BlockedOrders from '../BlockedOrders';
import ButtonApp from 'Shared/Button';
import AddIcon from '@mui/icons-material/Add';
import RenderOnDemandThenHide from 'Components/RenderOnDemandThenHide';
import CustomColumn from 'Shared/CustomColumn';
import useMultiSelect from 'Shared/Hooks/useMultiSelect';
import { useDispatch, useSelector } from 'react-redux';
import { makeSelectOpenState } from 'Components/Traceability/selectors';
import useStyles from './style';
import RecoveryList from '../RecoveryList/RecoveryList';
import { clientCustomColumns } from '../RecoveryList/constants';
import { setClientInfo, setOpenClient } from '../RecoveryView/clientInfoSlice';

const RecoveryListTabs = () => {
  const {
    state: { user },
  } = useContext(UserContext);
  const openAddClient = useSelector(makeSelectOpenState());
  const dispatch = useDispatch();
  // const [openAddClient, setOpenAddClient] = useState(false);
  const { selectedItem, onSelectOne, extendedColumns } = useMultiSelect('id', clientCustomColumns);
  const isRECOUVREMENT = ['RECOUVREMENT'].includes(user.role);
  const classes = useStyles();
  const onHandleAddClient = (nextState) => {
    if (nextState === undefined) {
      dispatch(setOpenClient(!openAddClient));
    } else {
      dispatch(setClientInfo(nextState));
    }
  };
  return (
    <Paper elevation={0} classes={{ root: classes.paper }}>
      <Box sx={{ display: 'flex', mb: 2.5 }}>
        <Typography sx={{ font: 'normal 600 24px Montserrat', mr: 'auto' }}>
          Liste Des Clients
        </Typography>
        <RenderOnDemandThenHide visible={isRECOUVREMENT}>
          <CustomColumn
            customColumns={clientCustomColumns}
            setSelectedCustomColumns={onSelectOne}
            selectedCustomColumns={selectedItem}
          />
          <ButtonApp
            label="Ajouter"
            startIcon={<AddIcon />}
            onClick={() => onHandleAddClient({ isOpen: true, editMode: true })}
            style={{ marginLeft: 10 }}
          />
        </RenderOnDemandThenHide>
      </Box>
      <RecoveryList
        isRECOUVREMENT={isRECOUVREMENT}
        extendedColumns={extendedColumns}
        // openClient={openAddClient}
        onCloseClientView={onHandleAddClient}
      />
    </Paper>
  );
  /*
  return (
      {tab === 1 && !isCommercialOrSales && !isSAV && <BlockedOrders />}
  ); */
};

export default RecoveryListTabs;
